module.exports = __webpack_public_path__ + "images/brand-id1-4ef3360292df6b378d5ce7bafbc21e36.jpg";